// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__geQrI {
  position: relative;
  width: 100%;
  height: 64px;
}

.styles_input__GFzWS {
  width: 100%;
  height: 100%;
  padding: 16px;
  font-weight: 300;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: -0.015em;
  text-transform: capitalize;
  color: rgba(255, 255, 255, 0.5);
  background-color: transparent;
  border-radius: 16px;
  border: 1px solid #414141;
  outline: none;
  transition: 0.8s;
}
.styles_input__GFzWS:not([value=""]) {
  font-weight: 500;
  color: #ffffff;
}
.styles_input__GFzWS:hover {
  padding: 17px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.7);
  border: 1px solid #b6b6b6;
  transition: 0.8s;
}
.styles_input__GFzWS:focus {
  padding: 16px;
  font-weight: 500;
  color: #ffffff;
  border: 1px solid #b6b6b6;
  transition: 0.8s;
}
.styles_input__GFzWS::placeholder {
  font-weight: 300;
  color: rgba(255, 255, 255, 0.5);
}

.styles_inputError__3Ck\\+a {
  border: 1px solid #d33030;
}
.styles_inputError__3Ck\\+a:hover {
  border: 1px solid #d33030;
}
.styles_inputError__3Ck\\+a:focus {
  border: 1px solid #d33030;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/input/styles.module.scss","webpack://./src/assets/styles/variables/colors.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,0BAAA;EACA,+BCXS;EDYT,6BAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;AADF;AAGE;EACE,gBAAA;EACA,cC1BI;ADyBR;AAIE;EACE,aAAA;EACA,gBAAA;EACA,+BCzBO;ED0BP,yBAAA;EACA,gBAAA;AAFJ;AAKE;EACE,aAAA;EACA,gBAAA;EACA,cCxCI;EDyCJ,yBAAA;EACA,gBAAA;AAHJ;AAME;EACE,gBAAA;EACA,+BCzCO;ADqCX;;AAQA;EACE,yBAAA;AALF;AAOE;EACE,yBAAA;AALJ;AAQE;EACE,yBAAA;AANJ","sourcesContent":["@import './src/assets/styles/variables/colors';\n\n.wrapper {\n  position: relative;\n  width: 100%;\n  height: 64px;\n}\n\n.input {\n  width: 100%;\n  height: 100%;\n  padding: 16px;\n  font-weight: 300;\n  font-size: 18px;\n  line-height: 22px;\n  letter-spacing: -0.015em;\n  text-transform: capitalize;\n  color: $white-50;\n  background-color: transparent;\n  border-radius: 16px;\n  border: 1px solid $grey-input;\n  outline: none;\n  transition: 0.8s;\n\n  &:not([value='']) {\n    font-weight: 500;\n    color: $white;\n  }\n\n  &:hover {\n    padding: 17px;\n    font-weight: 500;\n    color: $white-70;\n    border: 1px solid $grey-nav;\n    transition: 0.8s;\n  }\n\n  &:focus {\n    padding: 16px;\n    font-weight: 500;\n    color: $white;\n    border: 1px solid $grey-nav;\n    transition: 0.8s;\n  }\n\n  &::placeholder {\n    font-weight: 300;\n    color: $white-50;\n  }\n}\n\n.inputError {\n  border: 1px solid $red;\n\n  &:hover {\n    border: 1px solid $red;\n  }\n\n  &:focus {\n    border: 1px solid $red;\n  }\n}\n","$white: #ffffff;\n$white-3: rgba($white, 0.03);\n$white-4: rgba($white, 0.04);\n$white-5: rgba($white, 0.05);\n$white-10: rgba($white, 0.1);\n$white-30: rgba($white, 0.3);\n$white-50: rgba($white, 0.5);\n$white-70: rgba($white, 0.7);\n$white-80: rgba($white, 0.8);\n$white-90: rgba($white, 0.9);\n$pink: #ff136d;\n$pink-10: rgba($pink, 0.1);\n$pink-15: rgba($pink, 0.15);\n$black: #000000;\n$black-5: rgba($black, 0.05);\n$black-15: rgba($black, 0.15);\n$black-26: rgba($black, 0.26);\n$black-30: rgba($black, 0.3);\n$black-70: rgba($black, 0.7);\n$black-87: rgba($black, 0.87);\n$black-bg: #100f0f;\n$black-nav-bg: #080808;\n$black-footer: #0a0a0a;\n$blue: #443de9;\n$blue-btn: #453fd6;\n$blue-btn-15: rgba($blue-btn, 0.15);\n$blue-btn-40: rgba($blue-btn, 0.4);\n$grey-nav: #b6b6b6;\n$grey-input: #414141;\n$orange: #f5b300;\n$orange-5: rgba($orange, 0.05);\n$green: #12bc56;\n$red: #d33030;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__geQrI`,
	"input": `styles_input__GFzWS`,
	"inputError": `styles_inputError__3Ck+a`
};
export default ___CSS_LOADER_EXPORT___;
